type PortableTextSpan = { _type: 'span'; text: string }
type PortableTextBlock = { _type: string; children?: PortableTextSpan[] }

export function getPortableTextExcerpt(blocks: unknown[] | null | undefined, maxLength = 100): string {
  if (!blocks?.length) return ''

  const plainText = (blocks as PortableTextBlock[])
    .filter((block) => block._type === 'block')
    .map((block) => block.children?.map((span) => span.text).join('') ?? '')
    .join(' ')
    .trim()

  if (plainText.length <= maxLength) return plainText

  const truncated = plainText.slice(0, maxLength)
  return `${truncated.slice(0, truncated.lastIndexOf(' '))}…`
}
